﻿import { Rest_API } from "../../system/services/rest_api";

import { age_cat } from "./../objects/v1_3/web_engine/age_cat";

import { filter } from "./../objects/v1_3/web_engine/filter";
import { filters } from "./../objects/v1_3/web_engine/filters";

import { local_filter } from "../objects/front_end/search/local_filter";

import { country } from "../objects/v1_3/web_engine/country";

import { currency } from "../objects/v1_2/Currency/currency";
import { stringifyQuery } from "vue-router";
import { filtertag } from "../objects/v1_3/web_engine/filtertag";
import { currency_info } from "../objects/v1_2/Currency/currency_info";

import store from "../../../tms/booking_engine/store/index";

export class Web_Engine {

    Rest : Rest_API = new Rest_API();

    public Get_Agent_Band_App_Id(): string {
        return store.getters.get_Agent_Login?.agency.band_app_id ?? import.meta.env.VITE_APP_ID;
    }
    public async Get_Passengers(): Promise<age_cat> {
        return this.Rest.Get_Data<age_cat>(import.meta.env.VITE_APP_URL + "/api/v1.3/" + this.Get_Agent_Band_App_Id() + "/web_engine/age_category").then(response => { return response.json(); });
    }
    public async Get_Passengers_By_Brand(brand : string): Promise<age_cat> {
        var app_id : string = this.Get_Agent_Band_App_Id();
        var app_url = import.meta.env.VITE_APP_URL;

        if (brand != undefined && brand != "") {
            if (brand == 'Haggis') {
                app_id = import.meta.env.VITE_APP_ID_HAG;
                app_url = import.meta.env.VITE_APP_URL_HAG;
            } else if (brand = 'Hex') {
                app_id = import.meta.env.VITE_APP_ID_HEX;
                app_url = import.meta.env.VITE_APP_URL_HEX;
            }
        }

        return this.Rest.Get_Data<age_cat>(app_url + "/api/v1.3/" + app_id + "/web_engine/age_category").then(response => { return response.json(); });
    }
    public get_Booking_URL(): string {
        console.log("Booking URL " + String(import.meta.env.VITE_BOOKING_ENGINE))

        if (String(import.meta.env.VITE_BOOKING_ENGINE) + "" != "" && import.meta.env.VITE_BOOKING_ENGINE != undefined) {
            return String(import.meta.env.VITE_BOOKING_ENGINE);
        }

        return "book";
    }
    public async Download_Filter_Info(): Promise<filters> {
        return this.Rest.Get_Data<filters>(import.meta.env.VITE_APP_URL + "/api/v1.3/" + this.Get_Agent_Band_App_Id() + "/web_engine/filter").then(response => { return response.json(); });
    }
    public async Get_Filters(): Promise<local_filter[]> {
        let filters: filters = await this.Download_Filter_Info();
        let Return_Filters: local_filter[] = [];
        let index = 0;

        filters.filters.forEach(filter => {
            Return_Filters.push({
                name: filter.name,
                isOpen: false,
                selectedTag: new filtertag(),
                tags: filter.tags
            })
        });

        return Return_Filters;
    }
    public async Get_Countries(): Promise<country> {
        return await this.Rest.Get_Data<filter[]>(import.meta.env.VITE_APP_URL + "/api/v1.3/" + this.Get_Agent_Band_App_Id() + "/web_engine/country").then(response => { return response.json(); });
    }
    public async Get_Currency(): Promise<currency> {
        return await this.Rest.Get_Data<currency>(import.meta.env.VITE_APP_URL + "/api/v1.3/" + this.Get_Agent_Band_App_Id() + "/web_engine/country/" + import.meta.env.VITE_DEFAULT_COUNTRY).then(response => { return response.json(); });
    }
    public async Get_User_Currency(): Promise<currency> {
        let returnCurrency = await this.Rest.Get_Data<currency>(import.meta.env.VITE_IP_URL + "/api/v1.3/web_engine/currency").then(response => { return response.json(); });
        if(returnCurrency.currency_info == null) {
            returnCurrency = await this.Get_Currency();
        }
        return returnCurrency
    }
    public async Get_Currency_By_Country_Code(country_code: string): Promise<currency_info> {
        return await this.Rest.Get_Data<currency>(import.meta.env.VITE_IP_URL + "/api/v1.3/web_engine/currency/iso_currency_code/" + country_code.toUpperCase()).then(response => { return response.json(); });
    }
    public async Initialise_Currency(store: any, currency_override: string) {

        let user_currency : currency; 
        
        if (currency_override != '') 
        {
            user_currency = this.Get_Currency_Override(currency_override);
        } 
        else
        {
            user_currency = await this.Get_User_Currency();
        }

        store.commit('Initialise_Currency', { Currency_Details: user_currency });

        if (store.getters.get_Agent_Login?.currencies?.length > 0) {
            let Currency_Info = store.getters.get_Currency;
            Currency_Info.currency_info = store.getters.get_Agent_Login.currencies[0];
            store.commit('Initialise_Currency', { Currency_Details: Currency_Info });
        }
    }
    getSession_ID(): string {
        let url = window.location.href;
        let params = url.split("/");
        let displayText = "";

        if (params.length > 0) {
            if (this.isValidGUID(params[params.length - 1])) {
                return params[params.length - 1];
            }
        }

        return displayText;
    }
    isValidGUID(value: string): boolean {
        const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        return guidRegex.test(value);
    }
    public Get_Currency_Override(currency_override : string) : currency {
        const currency_aud : currency = {country:'Override - Australia', dialing_code:'61', iso_country_code:'AU', currency_info:{currency:'AUD', currency_mask:'$#,##0.00 ', iso_currency_code:'AUD' }};
        const currency_cad : currency = {country:'Override - Canada', dialing_code:'1', iso_country_code:'CA', currency_info:{currency:'CAD', currency_mask:'$#,##0.00 ', iso_currency_code:'CAD' }};
        const currency_eur : currency = {country:'Override - Germany', dialing_code:'49', iso_country_code:'DE', currency_info:{currency:'EUR', currency_mask:'€#,##0.00 ', iso_currency_code:'EUR' }};
        const currency_gbp : currency = {country:'Override - United Kingdom', dialing_code:'44', iso_country_code:'GB', currency_info:{currency:'GBP', currency_mask:'£#,##0.00 ', iso_currency_code:'GBP' }};
        const currency_nzd : currency = {country:'Override - New Zealand', dialing_code:'64', iso_country_code:'NZ', currency_info:{currency:'NZD', currency_mask:'$#,##0.00 ', iso_currency_code:'NZD' }};
        const currency_usd : currency = {country:'Override - United States of America', dialing_code:'1', iso_country_code:'US', currency_info:{currency:'USD', currency_mask:'$#,##0.00 ', iso_currency_code:'USD' }};
        const currency_zar : currency = {country:'Override - South Africa', dialing_code:'27', iso_country_code:'ZA', currency_info:{currency:'ZAR', currency_mask:'R#,##0.00 ', iso_currency_code:'ZAR' }};
    
        switch(currency_override.toLowerCase()) {
            case "aud": {
                return currency_aud;
                break;
            }
            case "cad": {
                return currency_cad;
                break;
            }
            case "eur": {
                return currency_eur;
                break;
            }
            case "gbp": {
                return currency_gbp;
                break;
            }
            case "nzd": {
                return currency_nzd;
                break;
            }
            case "usd": {
                return currency_usd;
                break;
            }
            case "zar": {
                return currency_zar;
                break;
            }
            default: {
                return currency_gbp;
                break;
            }
        }
    }
    
}